import {Table} from "antd";
import useScheduleTableService from "./scheduleTableService";
import "./style.less"
import {ScheduleTableProps} from "../../../../types/schedule";
import {FC} from "react";

const ScheduleTable: FC<ScheduleTableProps> = (props) => {
  const {scheduleController} = props
  const {columns} = useScheduleTableService({scheduleController})


  return <Table loading={scheduleController.isLoading} pagination={false} columns={columns}
                dataSource={scheduleController.sortedTableData}
                rowKey={(record) => record.$id || (typeof record.staff === "object" ? record.staff.$id || record.staff.fullName : String(record.staff))}
                locale={{emptyText: "Лікарів за вашим запитом не знайдено"}}
                className="schedule_table" scroll={{x: 760}}/>
}
export default ScheduleTable
